<template>
  <div class="body">
    <div v-show="isReportsLoading" class="preloader">
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <report-picker
      v-for="(report, index) in reports"
      :key="index"
      :showTo="getIsVip(report)"
      :range="false"
      :confirm="true"
      :uri="report.uri"
      :reportLoading="loading"
      :title="report.label"
      :params="report.params"
      @buttonClick="onButtonClick"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FhsAxios } from "../../services/axios";
import ReportPicker from "@/components/report/ReportPicker";
import user from "@/store/modules/user";
import brokers from "@/store/modules/brokers";
import { HalfCircleSpinner } from "epic-spinners";
import config from "@/config/index";

export default {
  data() {
    return {
      loading: false
    };
  },
  components: {
    "report-picker": ReportPicker,
    spinner: HalfCircleSpinner
  },
  computed: {
    ...mapGetters(["reports", "isReportsLoading", "selectedPortfolio"])
  },
  methods: {
    getIsVip(report) {
      let description = report.description;
      description = description.split("\n");
      let reg = /VIP|FHS\b/gm;
      let type = description[0].match(reg);
      if (type && type.length > 0) {
        return type[0];
      }
      return "";
    },
    onButtonClick(format, dateRange, uri, params) {
      let sendParams = [];
      this.loading = true;
      if (!dateRange) {
        alert("Выберите дату");
        this.loading = false;
        return;
      }
      params.map(function(value) {
        if (value.id === "bDate") {
          sendParams.push({ id: value.id, value: dateRange[0] });
        }
        if (value.id === "eDate") {
          sendParams.push({ id: value.id, value: dateRange[1] });
        }
        if (value.id.toLowerCase().indexOf("ddate") !== -1) {
          sendParams.push({ id: value.id, value: dateRange });
        }
      });

      if (user.state.isUserVIP == "1" && this.selectedPortfolio != "all") {
        sendParams.push({ id: "brokerId", value: this.selectedPortfolio });
      }

      FhsAxios.post("reports/account-statement-file", {
        format: format,
        uri: uri,
        params: sendParams
      })
        .then(response => {
          if (response.data.result.status == 0) {
            this.$toasted.error("Произошла ошибка при формировании отчёта");
          }

          this.loading = false;
          const url = config.fileAbsUrl + "/v1/" + response.data.result.url;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("target", "_blank"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => {
          this.loading = false;
          // console.error(e);
        });
    }
  },
  mounted() {
    this.$store.dispatch("fetchAccountStatementList");
  }
};
</script>

<style scoped>
.body {
  padding: 40px 0 0 40px;
}
</style>
